import styled from "@emotion/styled";
import {PureButton} from "components/Common/Buttons";
import {breakpoints} from "assets/theme";

export const ModalBackdrop = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 14px;
	z-index: 999;

	&:after {
		z-index: 998;
		content: "";
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background: #000000;
		opacity: 0.6;
	}
`;

export const Modal = styled.div`
	position: relative;
	z-index: 1000;
	max-width: 600px;
	width: 100%;
	background: ${({theme}) => theme.colors.brand.black};
	border-radius: 20px;
	padding: 22px 26px;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
`;

export const ModalText = styled.p`
	font-style: normal;
	font-size: 20px;
	line-height: 24px;
	color: ${({theme}) => theme.colors.text.white};
	margin-bottom: 20px;
	text-align: center;
`;

export const ModalTitle = styled(ModalText)`
	font-weight: 600;
	margin: 60px 0 20px 0;
`;

export const ModalCloseButton = styled(PureButton)`
	position: absolute;
	right: 13px;
	top: 16px;
	cursor: pointer;
`;

export const ModalButtons = styled.div`
	max-width: 300px;
	width: 100%;
	display: flex;
	justify-content: center;
	gap: 12px;

	button {
		width: 100%;
	}

	&.half {
		button {
			width: 50%;
		}
	}

	@media screen and (max-width: ${breakpoints.mobile}) {
		&.mobile {
			flex-direction: column;
		}
	}
`;
